'use client';

import type React from 'react';
import ProductionLineListWrapper from './wrapper';

const ProductionLineHomePage: React.FC = () => {
  return (
    <div className="px-6 py-6 md:px-14">
      <div className="header mb-4">
        <h1 className="text-2xl font-bold">
          Welcome to the Production reporting tool
        </h1>
        <p className="text-sm text-gray-400">
          The platform integrates data from the plant, linking instrumentation
          and real-time field data for comprehensive production oversight.
        </p>
      </div>
      <ProductionLineListWrapper />
    </div>
  );
};

export default ProductionLineHomePage;
